import { AlertTriangle } from "lucide-react"; // Importando um ícone de alerta

export default function Bloqueado() {
  return (
    <div className="h-screen flex flex-col justify-center items-center font-questrial bg-gray-100 text-gray-700">
      <div className="flex flex-col items-center text-center">
        <AlertTriangle className="w-16 h-16 text-red-500 mb-4" />
        <h1 className="text-3xl font-bold mb-2">Acesso Bloqueado</h1>
        <p className="text-lg mb-6">
          Você não tem permissão para acessar esta página. <br />
          Entre em contato com o administrador se acredita que isso é um erro.
        </p>
        <div className="flex gap-4">
          <button
            onClick={() => (window.location.href = "/")}
            className="px-6 py-3 bg-gray-500 text-white font-semibold rounded-lg hover:bg-blue-600"
          >
            Voltar à Página de Login
          </button>
          
        </div>
      </div>
    </div>
  );
}
